class Prop {
    constructor(name, key) {
        this.name = name
        this.key = key
    }
}

class Item {
    constructor(key, title) {
        this.key = key
        this.title = title
        this.props = []
    }

    addProp(name, key = '') {
        const prop = new Prop(name, key)
        this.props.push(prop)
    }

    getProps() {
        return this.props
    }

    getTitle() {
        return this.title
    }

    getKey() {
        return this.key
    }
}

class Model {
    constructor(key, title) {
        this.key = key
        this.title = title
        this.data = []
    }

    addItem(key, title, props) {
        const index = this.data.findIndex(d => d.key === key)
        let data = {}

        if (index == -1) {
            data = new Item(key, title)
        } else {
            data = this.data[index]
            this.data.splice(index, 1)
        }

        props.forEach(prop => {
            data.addProp(prop.name, prop.key)
        })

        this.data.push(data)
    }

    getData() {
        return this.data
    }

    getTitle() {
        return this.title
    }

    getKey() {
        return this.key
    }
}

export default Model
